import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const SIMCARDS_REQUESTS = gql`
  query GetSimCards ($unityId: Int!) {
    simCardsAvailable(unityId: $unityId, limit: 100, offset: 0) {
      data {
        codigo
        master
        status
        dataCadastro
        iccid
        ddd
        telefone
        clienteMaster {
          codigo
          razaoSocial
        }
      }
      totalRecords
    }
  }
`;

export const getAllSimCards = async (unityId) => {
  
    const response = await queryAllPages(client, {
      query: SIMCARDS_REQUESTS,
      variables: {
        unityId: parseInt(unityId),
      }
    });
    const { data } = response.data.simCardsAvailable;
    return data;
  
}
